import style from './Hamburger.module.scss';
import { motion } from 'framer-motion';

interface IHamburger {
  isOpen: boolean;
  onChange: (open: boolean) => void;
}

export function Hamburger({ isOpen, onChange }: IHamburger) {
  const variant = isOpen ? 'opened' : 'closed';
  const top = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: 45,
      translateY: 9,
    },
  };
  const center = {
    closed: {
      opacity: 1,
    },
    opened: {
      opacity: 0,
    },
  };
  const bottom = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: -45,
      translateY: -8,
    },
  };
  return (
    <motion.div animate={variant} onClick={() => onChange(!isOpen)} className={style.Hamburger}>
      <motion.div variants={top} className={style.line}></motion.div>
      <motion.div variants={center} className={style.line}></motion.div>
      <motion.div variants={bottom} className={style.line}></motion.div>
    </motion.div>
  );
}
